import { render, staticRenderFns } from "./payg-checkout-complete.vue?vue&type=template&id=18f12e54&"
import script from "./payg-checkout-complete.vue?vue&type=script&lang=js&"
export * from "./payg-checkout-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports